var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"help-icon",on:{"click":_vm.openPopup}},[_c('i',{staticClass:"fa fa-info-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }